/**
 * CommandLists - manages command execution stack
 */

import { Globals } from '../core/Globals';

// Forward declaration
declare namespace GameCommands {
    function runCommands(): Promise<boolean>;
}

interface CommandStackItem {
    obj: any;
    act: any;
    autoShift: boolean;
    commands: any[];
    additionalData?: any;
}

// Legacy compatibility stub. Patch 0022 removes runtime dependence on CommandLists.
export const CommandLists = {
    stack: [
        { obj: null, act: null, autoShift: false, commands: [] } as CommandStackItem
    ] as CommandStackItem[],

    startNestedCommandList: function (params?: { obj?: any; act?: any }): CommandStackItem {
        params = params || {};
        const newStackParams: CommandStackItem = {
            obj: params.obj || this.objectBeingActedUpon(),
            act: params.act,
            autoShift: false,
            commands: [],
        };
        this.stack.unshift(newStackParams);
        return newStackParams;
    },

    finishNestedCommandList: function (commandList: CommandStackItem): void {
        commandList.autoShift = true;
        this.unshiftEmptyStacks();
        //(window as any).GameCommands?.runCommands?.();
    },

    nextCommand: function (): any {
        this.unshiftEmptyStacks();
        return this.stack[0].commands[0];
    },

    shiftCommand: function (): any {
        this.unshiftEmptyStacks();
        return this.stack[0].commands.shift();
    },

    addToFront: function (command: any, commandList?: any): void {
        if(commandList == undefined) commandList = this.stack[0];
        if (Globals.commandQueueEmptiedSinceCheckpoint) {
            Globals.hasUnsavedProgress = true;
        }
        commandList.commands.unshift(command);
    },

    addToEnd: function (command: any, commandList?: any): void {
        if(commandList == undefined) commandList = this.stack[0];
        if (Globals.commandQueueEmptiedSinceCheckpoint) {
            Globals.hasUnsavedProgress = true;
        }
        commandList.commands.push(command);
    },

    getCurrentStack: function (): CommandStackItem {
        return this.stack[0];
    },

    getStackLevel: function (): number {
        return this.stack.length;
    },

    setAdditionalData: function (additionalData: any): void {
        for (let i = 0; i < this.stack.length; i++) {
            if (this.stack[i].act) {
                this.stack[i].additionalData = additionalData;
                return;
            }
        }
    },

    lastAdditionalData: function (): any {
        for (let i = 0; i < this.stack.length; i++) {
            if (this.stack[i].act) {
                return this.stack[i].additionalData;
            }
        }
        return undefined;
    },

    objectBeingActedUpon: function (): any {
        for (let i = 0; i < this.stack.length; i++) {
            if (this.stack[i].obj) {
                return this.stack[i].obj;
            }
        }
        return null;
    },

    actionBeingTaken: function (): any {
        for (let i = 0; i < this.stack.length; i++) {
            if (this.stack[i].act) {
                return this.stack[i].act;
            }
        }
        return null;
    },

    commandCount: function (): number {
        this.unshiftEmptyStacks();
        let result = this.stack[0].commands.length;
        for (let i = 1; i < this.stack.length; i++) {
            if (!this.stack[i - 1].autoShift) {
                return result;
            }
            result += this.stack[i].commands.length;
        }
        return result;
    },

    unshiftEmptyStacks: function (): void {
        while (this.stack.length > 1 && this.stack[0].commands.length === 0) {
            if (this.stack[0].autoShift) {
                this.stack.shift();
            } else {
                return;
            }
        }
    },

    reset: function (): void {
        this.stack = [
            { obj: null, act: null, autoShift: false, commands: [] }
        ];
    },
};

// Make available globally
(window as any).CommandLists = CommandLists;
